module.exports = __webpack_public_path__ + "static/media/3040164000_01.ecb29e88.jpg";